import styled, { css } from 'styled-components';

export const PromotionsDrawerContentContainer = styled.div<{ withoutPromotions: boolean }>`
	overflow: hidden auto;
	gap: 1.5rem;
	padding: 16px;
	display: flex;
	flex-direction: column;

	${({ withoutPromotions }) =>
		withoutPromotions &&
		css`
			height: 100%;

			> div {
				height: 100%;
			}
		`}
`;
